import { Dialog } from "@headlessui/react";
import { FormBox, ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { Groups } from "../../model/Groups";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { ConstMessage } from "../../config/const";
import { Spiner } from "../../components/spinner/Spiner";

export type GroupAdminListModallProps = {
  group?: Groups;
  cols: GridCol[];
  rows: GridRow[];
  adminSettingToggle: () => void;
   isLode?: boolean;
}

export const GroupAdminListModal = ({
  open,
  toggle,
  adminSettingToggle,
  closeOnClickOutside,
  group,
  cols,
  rows,
  isLode = false,
}: ModalProp & GroupAdminListModallProps) => {

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <Dialog.Title
                as="h3"
                className="text-left text-lg font-medium leading-6 text-gray-900"
              >
                管理者一覧
              </Dialog.Title>
              <div className="overflow-y-auto">
                <div className="px-2 text-left pb-8 h-[500px] ">
                  <div className="flex">
                    {rows.length == 0 ? (
                        <h2 className="ml-1 mt-3 text-red-500">
                          {ConstMessage.MSG_OPERATION_NOT_POSSIBLE_NO_GROUPADMIN}
                        </h2>
                      ) :
                      <></>
                    }
                    <FormBox className="flex sm:items-center" gridcol="ml-auto flex justify-end">
                      <Button
                        outline
                        size={'sm'}
                        children={"管理者設定"}
                        className={"w-fit"}
                        onClick={adminSettingToggle}
                      />
                    </FormBox>
                  </div>
                  <div className="pt-4">
                    {isLode ? (
                      <Spiner />
                      ) : (
                      <TableList
                        footer={false}
                        gridCol={cols}
                        gridRow={rows}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1"
              outline
              onClick={toggle}
              children={"閉じる"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  )
}